import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminStatsChannels = lazy(() => import("@/pages/admin/AdminStatsChannels"));

export const Route = createFileRoute("/admin/statistik/kanaler")({
  component: () => <AdminStatsChannels />,
});
